// The laptop and Wi-Fi eligibility line (Phase 5 PR 5.3, Q12a: the redesign's
// `redesignLaptopEligibilitySummary`, copied out of the redesign tree). One
// source for every page that states the benefit: the IT lander's legal notes
// and support card (content/itInfoOverview.ts) and the /experience tech pack
// (Phase 6). The qualifier ("eligible", "who demonstrate need") is part of the
// claim: change the sentence here only, never retype it in a page.

export const LAPTOP_ELIGIBILITY =
  'Eligible online degree students who demonstrate need may receive a laptop and mobile Wi-Fi access at no additional cost.'
